import { render, staticRenderFns } from "./cpt-dataV-decoration.vue?vue&type=template&id=39eff224&scoped=true"
import script from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eff224",
  null
  
)

export default component.exports